import { gql } from '@apollo/client';

export interface ManualExitOrderPoolResponse {
    manualExitOrderPool: boolean;
}

export interface ManualExitOrderPoolVariables {
    orderIds: number[];
}

export const MANUAL_EXIT_ORDER_POOL = gql`
    mutation ManualExitOrderPool($orderIds: [Long!]!) {
        manualExitOrderPool(orderIds: $orderIds)
    }
`;

